import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
export var Counter = function Counter(_ref) {
  var className = _ref.className,
      value = _ref.value,
      setValue = _ref.setValue,
      _ref$counterValues = _ref.counterValues,
      counterValues = _ref$counterValues === void 0 ? {} : _ref$counterValues,
      _ref$userInput = _ref.userInput,
      userInput = _ref$userInput === void 0 ? true : _ref$userInput,
      children = _ref.children,
      disabled = _ref.disabled;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var min = Number(counterValues === null || counterValues === void 0 ? void 0 : counterValues.min) || 0;
  var max = Number(counterValues === null || counterValues === void 0 ? void 0 : counterValues.max) || 99;
  setCount = setValue || setCount;
  count = Number(value) || count;

  var handleChange = function handleChange(event) {
    var value = Number(event.target.value);

    if (value < min) {
      value = min;
    } else if (value > max) {
      value = max;
    }

    return setCount(Number(value));
  };

  var addCountHandler = function addCountHandler() {
    console.log('Count handler added');

    if (max === null || max === undefined) {
      setCount(count + 1);
      return;
    } else {
      if (count >= max) {
        return;
      }

      setCount(count + 1);
    }
  };

  var removeCountHandler = function removeCountHandler() {
    if (count <= min) {
      return;
    }

    var counter = count - 1;

    if (counter <= 0) {
      counter = 1;
    }

    setCount(counter);
  };

  var atMax = count >= max;
  var atMin = count <= min;

  if (atMin === 0) {
    atMin = 1;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-menu-counter cb-menu-counter--lower ".concat(className)
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: removeCountHandler,
    className: "cb-menu-counter__minus ".concat(atMin ? "is-disabled" : "")
  }), /*#__PURE__*/React.createElement("input", {
    type: "number",
    pattern: "^[1-9]\\d*$",
    min: min,
    disabled: !userInput || disabled,
    onChange: handleChange,
    value: count,
    className: "cb-menu-counter__input bg-white"
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: count >= max || disabled,
    onClick: addCountHandler,
    className: "cb-menu-counter__plus ".concat(atMax ? "is-disabled" : "")
  }));
};